// components/calculator/ResultsSection.js
import React from 'react';
import {
  Paper,
  Typography,
  FormControlLabel,
  Checkbox,
  Grid,
  Card,
  CardContent,
  Divider
} from '@mui/material';

const ResultsSection = ({ calculatedData, showIVA, setShowIVA, IVA_RATE }) => {
  // Validación para evitar errores cuando calculatedData está incompleto
  if (!calculatedData || !calculatedData.montoBase) {
    return null;
  }

  // Función helper para formatear moneda
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || isNaN(amount)) {
      return '$0,00';
    }
    return amount.toLocaleString('es-AR', { minimumFractionDigits: 2 });
  };

  // Función helper para formatear porcentaje
  const formatPercentage = (percentage) => {
    if (percentage === null || percentage === undefined || isNaN(percentage)) {
      return '0,00';
    }
    return percentage.toFixed(2);
  };

  const months = [
    { 
      nombre: '🗓️ Septiembre', 
      monto: calculatedData.montoSep || 0, 
      porcentaje: calculatedData.porcentajeAcumSep || 0 
    },
    { 
      nombre: '🗓️ Octubre', 
      monto: calculatedData.montoOct || 0, 
      porcentaje: calculatedData.porcentajeAcumOct || 0 
    },
    { 
      nombre: '🗓️ Noviembre', 
      monto: calculatedData.montoNov || 0, 
      porcentaje: calculatedData.porcentajeAcumNov || 0 
    },
    { 
      nombre: '🗓️ Diciembre', 
      monto: calculatedData.montoDic || 0, 
      porcentaje: calculatedData.porcentajeAcumDic || 0 
    },
    { 
      nombre: '🗓️ Enero', 
      monto: calculatedData.montoEne || 0, 
      porcentaje: calculatedData.porcentajeAcumEne || 0 
    }
  ];

  return (
    <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
      <Typography variant="h5" gutterBottom>
        📊 Resultados por Mes
      </Typography>
      
      <FormControlLabel
        control={
          <Checkbox
            checked={showIVA}
            onChange={(e) => setShowIVA(e.target.checked)}
          />
        }
        label="Mostrar montos con IVA (21%)"
        sx={{ mb: 2 }}
      />

      <Grid container spacing={2}>
        {months.map((mes, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {mes.nombre}
                </Typography>
                <Typography variant="h5" color="primary">
                  ${formatCurrency(mes.monto)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  +{formatPercentage(mes.porcentaje)}% acumulado (Sin IVA)
                </Typography>
                {showIVA && (
                  <>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="h6" color="secondary">
                      ${formatCurrency(mes.monto * (1 + IVA_RATE))}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Con IVA (21%)
                    </Typography>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default ResultsSection;